import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-319dab70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-messages-subheader-inner" }
const _hoisted_2 = {
  key: 0,
  class: "chat-filter-header-badge"
}

import { IonPage, IonHeader, IonToolbar, IonTitle, IonButtons, IonMenuButton, IonContent, IonRouterOutlet, IonButton } from '@ionic/vue';
  import { computed } from 'vue';
  import { useRoute } from 'vue-router';
  import { storeToRefs } from 'pinia';
  import { useChatMensajesUiStore } from '@/stores/chatMensajesUiStore';
  import tools from '@/composables/tools';
  import userAuth from '@/composables/userAuth';
  import { mainStore } from '@/stores/mainStore';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BaseLayout',
  setup(__props) {

  const route = useRoute();
  const haySesion = computed(() => mainStore().isLogged || userAuth().hasToken());
  const chatUi = useChatMensajesUiStore();
  const { showOnlyUnread, unreadIncomingCount } = storeToRefs(chatUi);

  const onToggleChatUnreadFilter = () => {
    if (!showOnlyUnread.value && unreadIncomingCount.value === 0) {
      void tools().toast('No hay mensajes sin leer', 'warning', 2800);
      return;
    }
    chatUi.toggleShowOnlyUnread();
  };
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      (haySesion.value)
        ? (_openBlock(), _createBlock(_unref(IonHeader), { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonToolbar), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButtons), { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonMenuButton))
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonTitle), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$route.name), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_unref(route).name === 'Chat mensajes')
                ? (_openBlock(), _createBlock(_unref(IonToolbar), {
                    key: 0,
                    class: "chat-messages-subheader"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(_unref(IonButton), {
                          size: "small",
                          fill: _unref(showOnlyUnread) ? 'solid' : 'outline',
                          color: _unref(showOnlyUnread) ? 'primary' : 'medium',
                          class: "chat-filter-header-btn",
                          onClick: onToggleChatUnreadFilter
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(showOnlyUnread) ? 'Ver todos los mensajes' : 'Mostrar sólo no leídos') + " ", 1),
                            (!_unref(showOnlyUnread) && _unref(unreadIncomingCount) > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_2, " (" + _toDisplayString(_unref(unreadIncomingCount)) + ") ", 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["fill", "color"])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default"),
          _createVNode(_unref(IonRouterOutlet))
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})